import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus } from "lucide-react";
import { InlinePartnerForm } from "../forms/InlinePartnerForm";
import type { OrderFormData, PartnerOption, PartnerFormData } from "../types";

interface PartnerSectionProps {
  form: UseFormReturn<OrderFormData>;
  partners: PartnerOption[] | undefined;
  isCreating: boolean;
  setIsCreating: (value: boolean) => void;
  formData: PartnerFormData;
  setFormData: (data: PartnerFormData) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
}

export function PartnerSection({
  form,
  partners,
  isCreating,
  setIsCreating,
  formData,
  setFormData,
  onSubmit,
  isSubmitting,
}: PartnerSectionProps) {
  if (isCreating) {
    return (
      <InlinePartnerForm
        formData={formData}
        onChange={setFormData}
        onSubmit={onSubmit}
        onCancel={() => setIsCreating(false)}
        isSubmitting={isSubmitting}
      />
    );
  }

  return (
    <>
      <FormField
        control={form.control}
        name="partner_id"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Kumppani</FormLabel>
            <Select
              onValueChange={(value) => field.onChange(value === "none" ? undefined : value)}
              value={field.value || "none"}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Valitse kumppani (valinnainen)" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="none">Ei kumppania</SelectItem>
                {partners?.map((partner) => (
                  <SelectItem key={partner.id} value={partner.id}>
                    {partner.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => setIsCreating(true)}
        className="w-full"
      >
        <Plus className="mr-2 h-4 w-4" />
        Luo uusi kumppani
      </Button>
    </>
  );
}
